import { SocietyDirector } from 'types';

export const isActiveDirector = (director: SocietyDirector, date?: Date) => {
  if (!director) return false;
  if (director?.directorStatus === 'ACTIVE') return true;
  if (!director?.endDate) return true;

  const directorEndDate = new Date(director.endDate).getTime();
  const currentDate = date ? date.getTime() : new Date().getTime();

  return currentDate <= directorEndDate;
};

export const isActiveDirectorOnPast = (
  director: SocietyDirector,
  date: Date
) => {
  // 1. Basic validation - director must exist
  if (!director) return false;

  // 2. Validate initDate exists (required field)
  if (!director.initDate) return false;

  const targetDate = date.getTime();
  const directorInitDate = new Date(director.initDate).getTime();

  // 3. Director must have already started by the target date
  if (directorInitDate > targetDate) return false;

  // 4. If no endDate, director is still active (ongoing)
  if (!director.endDate) return true;

  const directorEndDate = new Date(director.endDate).getTime();

  // 5. Director must not have ended before the target date
  return directorEndDate >= targetDate;
};
